import { useNewVersionCheckStore } from '@libs/store/newVersion';
import { useRefreshSyncStore } from '@libs/store/refreshSync';
import { Box, Grow } from '@mui/material';

import { NewVersionBadge, type NewVersionBadgeProps } from '@shiftnex/framework/src/components/organisms/newVersion';
import { useEffect } from 'react';

type NewVersionContainerProps = Omit<NewVersionBadgeProps, 'localizationSubset' | 'onRefresh'> & {};
export const NewVersion = (props: NewVersionContainerProps) => {
  const isNewVersionAvailable = useNewVersionCheckStore((state) => state.isNewVersionAvailable);
  const { checkBuildTime, refreshApp } = useNewVersionCheckStore();

  const refreshTrigger = useRefreshSyncStore((state) => state.refreshTrigger);

  useEffect(() => {
    checkBuildTime();
  }, [refreshTrigger]);

  const handleRefresh = () => {
    refreshApp();
  };

  return (
    <Box>
      {isNewVersionAvailable && (
        <Grow in={true} timeout={150} mountOnEnter unmountOnExit>
          <Box>
            <NewVersionBadge localizationSubset="system.newVersionLabel" onRefresh={handleRefresh} {...props} />
          </Box>
        </Grow>
      )}
    </Box>
  );
};
